import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import EditAddress from "./editAddress";
const MySwal = withReactContent(Swal2);

const AdminPanelDisc = (props) => {
  const [disc, setDisc] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getDisc", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDisc(data[0].value);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div
              style={{ width: "100%", marginBottom: "1vh" }}
              className="closeBox"
            >
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>

              <p
                style={{
                  fontSize: "1.5vw",
                  fontWeight: "900",
                  textAlign: "left",
                }}
              >
                Ilość wykorzystanej powierzchni: {parseFloat(disc).toFixed(2)}{" "}
                GB
              </p>
              <p
                style={{
                  fontSize: "1.5vw",
                  fontWeight: "900",
                  textAlign: "left",
                }}
              >
                Zajęta powierzchnia:
                {" " +
                  parseFloat(parseFloat(+disc / 640).toFixed(2) * 100).toFixed(
                    2
                  )}
                %
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelDisc;
